import Swiper from 'swiper';
import { A11y, Autoplay, Controller, EffectFade, Navigation, Pagination } from 'swiper/modules';
export { Swiper };
export const SWIPER_MODULES = [Navigation, Pagination, Autoplay, EffectFade, Controller, A11y];
